const PrivacyPolicy = () => {
    return(
        <div className="max-w-3xl mx-auto py-8 px-4 my-10">
            <h1 className="text-2xl font-bold text-gray-900">Privacy Policy for BinaryBrains Web Development Agency</h1>

            <p className="mt-4 text-indigo-500 text-md font-semibold">1. Introduction</p>

            <p className="mt-2 text-gray-700">At BinaryBrains Web Development Agency (hereinafter "BinaryBrains," "we," "us," or "our"), we are committed to protecting your privacy and personal information. This privacy policy (hereinafter "Policy") describes how we collect, use, and share your personal information when you use our website or services.</p>

            <p className="mt-4 text-indigo-500 text-md font-semibold">2. Personal Information We Collect</p>

            <p className="mt-2 text-gray-700">We may collect personal information from you when you use our website or services, such as your name, email address, phone number, and company name. We may also collect information about your use of our website and services, such as your IP address and browser type.</p>

            <p className="mt-4 text-indigo-500 text-md font-semibold">3. How We Use Your Personal Information</p>

            <p className="mt-2 text-gray-700">We use your personal information to provide you with the web development services you request and to communicate with you about your project. We may also use your personal information to improve our website and services, or for marketing purposes, with your consent.</p>

            <p className="mt-4 text-indigo-500 text-md font-semibold">4. Sharing Your Personal Information</p>

            <p className="mt-2 text-gray-700">We will not share your personal information with third parties except as necessary to provide you with the web development services you request, or as required by law.</p>

            <p className="mt-4 text-indigo-500 text-md font-semibold">5. Data Security</p>

            <p className="mt-2 text-gray-700">We take reasonable measures to protect your personal information from unauthorized access or misuse. However, no method of transmission over the internet or method of electronic storage is completely secure, and we cannot guarantee the absolute security of your personal information.</p>

            <p className="mt-4 text-indigo-500 text-md font-semibold">6. Data Retention</p>

            <p className="mt-2 text-gray-700">We will retain your personal information for as long as necessary to provide you with the web development services you request, or as required by law.</p>

            <p className="mt-4 text-indigo-500 text-md font-semibold">7. Your Rights</p>

            <p className="mt-2 text-gray-700">You have the right to request access to, correction of, or deletion of your personal information. You also have the right to object to the processing of your personal information, or to withdraw your consent to the processing of your personal information. Please contact us at [insert contact email or phone number] if you wish to exercise any of these rights.</p>

            <p className="mt-4 text-indigo-500 text-md font-semibold">8. Changes to This Policy</p>

            <p className="mt-2 text-gray-700">We reserve the right to update this Policy from time to time. Any changes to this Policy will be effective immediately</p>

            <p className="mt-4 text-indigo-500 text-md font-semibold">9. Contact Us</p>

            <p className="mt-2 text-gray-700">If you have any questions or concerns about this Policy or our handling of your personal information, please contact us at [insert contact email or phone number].</p>

        </div>
    )
    }

export default PrivacyPolicy